import React from 'react';
import { handleBirthDateMaskOnInput } from '../../../../utils/payment/masks';
import ValidationIcon from '../../../icons/general/ValidationIcon';

interface BirthDateFieldProps {
  value: string;
  error?: string;
  isValid?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const BirthDateField: React.FC<BirthDateFieldProps> = ({
  value,
  error,
  isValid,
  onChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Aplica máscara
    handleBirthDateMaskOnInput(e);
    
    // Chama onChange com o valor mascarado
    onChange({
      target: {
        name: 'birth',
        value: e.target.value,
      },
    } as any);
  };

  const inputBaseClass = 'w-full p-3 border rounded-md shadow-sm text-sm focus:ring-primary focus:border-primary bg-input-bg-light dark:bg-input-bg-dark text-text-primary dark:text-gray-200 placeholder-gray-400 dark:placeholder-gray-500';
  const errorBorderClass = 'border-red-500';
  const normalBorderClass = 'border-medium-gray dark:border-gray-600';

  return (
    <div className="relative">
      <label htmlFor="birth" className="block text-sm font-medium text-text-secondary dark:text-gray-400 mb-1">
        Data de nascimento *<br/> <small>(Deve estar de acordo com o CPF)</small>
      </label>
      <div className="relative">
      <input
        type="text"
        id="birth"
        name="birth"
        value={value}
        onChange={handleChange}
        placeholder="DD/MM/AAAA"
        maxLength={10}
        className={`${inputBaseClass} ${error ? errorBorderClass : normalBorderClass}`}
        aria-describedby={error ? 'birth-error' : undefined}
      />
        <ValidationIcon isValid={isValid || false} />
      
      {error && (
        <p id="birth-error" className="text-xs text-red-500 mt-1">
          {error}
        </p>
      )}
      </div>
    </div>
  );
};

export default BirthDateField;
